export default __webpack_public_path__ + "images/696cfcfdd8c292702e3b4dcff99769e9.png";